import axios from "axios";
import { store } from "../store/store";

export default async function updateUser(user) {
  store.commit("incrementCarregando", true);
  try {
    const response = await axios({
      withCredentials: true,
      method: "post",
      data: {
        ...user,
      },
      url: `${process.env.VUE_APP_APIURL}/user/updateUser`,
    });
    store.commit("incrementCarregando", false);
    return response;
  } catch (error) {
    store.commit("incrementCarregando", false);
    return error.response;
  }
}
